/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import Radio from "@material-ui/core/Radio";

export default function OptionRadioButton({
  onChangeOption,
  selectedRadioButtonValue,
}) {
  const handleChange = (event) => {
    onChangeOption(event);
  };

  // 1: select a user
  // 2: save without user
  // 3: delete
  return (
    <View
      style={{
        width: 250,
        flexDirection: "row",
      }}
    >
      <Radio
        checked={selectedRadioButtonValue === "1"}
        onChange={handleChange}
        value={"1"}
        name={"radio-button-demo"}
        inputProps={{ "aria-label": "1" }}
      />
      {/* GreenRadio below not working, needs fixing */}
      {/* <GreenRadio
        checked={selectedRadioButtonValue === "1"}
        onChange={handleChange}
        value="1"
        name="radio-button-demo"
        inputProps={{ "aria-label": "1" }}
      /> */}
      <View style={{ width: 60 }} />
      <Radio
        checked={selectedRadioButtonValue === "2"}
        onChange={handleChange}
        value={"2"}
        name={"radio-button-demo"}
        inputProps={{ "aria-label": "2" }}
      />
      <View style={{ width: 60 }} />
      <Radio
        checked={selectedRadioButtonValue === "3"}
        onChange={handleChange}
        value={"3"}
        color={"default"}
        name={"radio-button-demo"}
        inputProps={{ "aria-label": "3" }}
      />
    </View>
  );
}
